// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Premium_cardContainer__2A0gZ","heading":"Premium_heading__38Upw","icon":"Premium_icon__1y7zY"};